<p-toast position="top-right" key="roles-mgmt-message"></p-toast>

<!--Add New Role-->
<p-dialog [(visible)]="displayNewRoleDialog" [blockScroll]="true" [modal]="true" class="new-role-dialog"
          [showHeader]="false"
          [closable]="false"
          [closeOnEscape]="false"
          [draggable]="false"
          [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
          [style]="{width: '35%'}">

    <div class="p-my-3" [formGroup]="createRoleForm">
        <div class="p-grid divider-bottom p-mt-0">
            <div class="p-col-12 p-text-left">
                <h5 class="p-m-0 p-text-primary">Add New Role</h5>
            </div>
        </div>

        <div class="p-grid p-ai-start p-mt-2">
            <div class="p-col-10">
                <div class="p-field">
                    <small>Role Name *</small>
                    <input formControlName="name" type="text" pInputText class="width-100">
                </div>
            </div>
            <div class="p-col-2 p-text-right">
                <div>
                    <small>Is Active ?</small>
                </div>
                <div class="p-mt-3">
                    <p-inputSwitch formControlName="isActive"></p-inputSwitch>
                </div>
            </div>
        </div>

        <div class="p-grid p-ai-start p-mt-2">
            <div class="p-col-12">
                <div class="p-field">
                    <small>
                        Parent Role
                    </small>
                    <p-dropdown placeholder="Select.." [options]="parentRoles"
                                [showClear]="createRoleForm?.value?.assignedParentRole"
                                formControlName="assignedParentRole" optionLabel="name"
                                appendTo="body"></p-dropdown>
                </div>
            </div>
        </div>


        <div class="p-grid p-mt-2">
            <div class="p-col-6 p-text-left">
                <button (click)="onClickOfCancel()" pButton pRipple class="p-button-danger p-button-sm"
                        label="Cancel"></button>
            </div>
            <div class="p-col-6 p-text-right">
                <button (click)="createRole()" pButton pRipple class="p-button-secondary p-button-sm"
                        label="Save"></button>
            </div>
        </div>
    </div>

</p-dialog>

<div class="p-mt-3" *ngIf="mode !== 'add'">
    <p-breadcrumb [home]="home" [model]="breadcrumbMenuModel"></p-breadcrumb>

    <div class="p-mt-3" [formGroup]="roleForm">

        <div class="p-grid p-ai-center p-jc-between p-pr-3">
            <div class="p-col-4">
                <div class="p-field">
                    <small>Role Name *</small>
                    <input pInputText [readOnly]="mode !== 'add'" class="width-100" type="text"
                           formControlName="name">
                </div>
            </div>

            <div class="p-col-4">
                <div class="p-d-flex p-ai-center p-jc-end">

                    <div class="p-field" style="width: 75%">
                        <small>
                            Parent Role
                        </small>
                        <p-dropdown placeholder="Select.." [options]="parentRoles"
                                    [showClear]="roleForm?.value?.assignedParentRole"
                                    [disabled]="!loggedInUser?.editRoles" formControlName="assignedParentRole"
                                    optionLabel="name"
                                    appendTo="body"></p-dropdown>
                    </div>

                    <div class="p-field p-ml-3">
                        <div>
                            <small>
                                IsActive ?
                            </small>
                        </div>
                        <div class="p-mt-2">
                            <p-inputSwitch [disabled]="!loggedInUser?.editRoles"
                                           formControlName="isActive"></p-inputSwitch>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <div class="p-grid p-mt-0 p-text-secondary divider-bottom p-py-3 p-ai-center">
            <div class="p-col-3 divider-right">
                <h5 class="p-m-0">Module</h5>
            </div>
            <div class="p-col-3 p-text-center divider-right">
                <h5 class="p-m-0">View</h5>
            </div>
            <div class="p-col-3 p-text-center divider-right">
                <h5 class="p-m-0"> Edit </h5>
            </div>
            <div class="p-col-3 p-text-center divider-right">
                <h5 class="p-m-0">Delete</h5>
            </div>
        </div>

        <!--Loader / Spinner-->
        <div style="min-height: 400px" class="p-d-flex p-ai-center p-jc-center" *ngIf="isLoading">
            <div class="p-text-center p-text-secondary">
                <div>
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
                </div>
                <div class="p-mt-3 p-text-bold">
                    Loading Access List !
                </div>
            </div>
        </div>

        <div *ngIf="roleModuleAccessListForm?.controls?.length > 0 && !isLoading">
            <div *ngFor="let roleModuleAccess of roleModuleAccessListForm?.controls">
                <div [formGroup]="roleModuleAccess" class="p-grid p-mt-0 p-py-3 divider-bottom p-py-2 p-ai-center">
                    <div class="p-col-3 divider-right">
                        {{roleModuleAccess?.value?.moduleName ? roleModuleAccess?.value?.moduleName : 'N/A'}}
                    </div>
                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox [disabled]="!loggedInUser?.editRoles"
                                    [formControl]="roleModuleAccess?.controls['isViewAllowed']"
                                    [binary]="true"></p-checkbox>
                    </div>
                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox [disabled]="!loggedInUser?.editRoles"
                                    [formControl]="roleModuleAccess?.controls['isEditAllowed']"
                                    [binary]="true"></p-checkbox>
                    </div>
                    <div class="p-col-3 p-text-center divider-right">
                        <p-checkbox [disabled]="!loggedInUser?.editRoles"
                                    [formControl]="roleModuleAccess?.controls['isDeleteAllowed']"
                                    [binary]="true"></p-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="loggedInUser?.editRoles" class="p-grid p-mt-0 p-pr-2">
            <div class="p-col-12 p-text-right">
                <button (click)="updateRole()" pButton pRipple label="Save"
                        class="p-button-secondary p-button-sm"></button>
            </div>
        </div>

    </div>

</div>
